import makeEvents from "../../../../helpers/event-creator.js";
const APP_EVENTS = makeEvents([
    'invite-form-submitted'
]);
export default APP_EVENTS;
